export const INVALID = 'invalid'
export const DEFINED = 'defined'
export const UNDEFINED = 'undefined'
export const BLANK = 'blank'
export const EQUAL = 'equal'
export const NOT_EQUAL = 'not_equal'
export const WRONG_TYPE = 'wrong_type'



// WEBPACK FOOTER //
// ./src/ErrorReasons.js